angular.module('bmsApp.employee').controller('EmployeeViewAdditionalPaymentsCtrl', function ($scope, $ngBootbox, notify, ngTableParams, EmployeeAdditionalPaymentSvc) {

	$scope.additionalPayments = {};
	$scope.additionalPayments.rangePickerConfig = angular.copy($scope.config.datePicker.range);
	$scope.additionalPayments.rangePickerConfig.options.opens = 'left';

	angular.extend($scope.tabs.additionalPayments, {
		select: function () {
			$scope.tabs.additionalPayments.load();
		},
		load: function () {
			if ($scope.tabs.additionalPayments.loaded !== true) {
				angular.extend($scope.additionalPayments, {
					loading: false,
					filters: {
						employee: $scope.employee.id,
						dateRange: {
							startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
							endDate: moment().format('YYYY-MM-DD')
						}
					},
					tableParams: new ngTableParams({
						scope: 'employee',
						page: 1,
						count: $scope.config.tabbedTable.params.count
					}, {
						counts: $scope.config.tabbedTable.settings.counts,
						getData: function ($defer, params) {
							$scope.additionalPayments.loading = true;
							var employeeId = $scope.employee.id;
							EmployeeAdditionalPaymentSvc.index(params.$params).then(function (response) {
								$defer.resolve(response.data.employee_additional_payment_collection);
								params.total(response.data.employee_additional_payment_total_count);
								$scope.additionalPayments.loading = false;
							});
						}
					}),
					dateChanged: function () {
						//console.info('date changed');
					},
					applyFilter: function () {
						var filters = angular.copy($scope.additionalPayments.filters);
						filters.dateRange = {
							fromDate: filters.dateRange.startDate,
							toDate: filters.dateRange.toDate
						};
						angular.extend($scope.additionalPayments.tableParams.$params.filter, filters);
					},
					form: function (additionalPayment) {
						if (!angular.isObject(additionalPayment)) {
							additionalPayment = {
								employee: {
									id: $scope.employee.id
								}
							};
						}
						EmployeeAdditionalPaymentSvc.showSaveModal(additionalPayment).then(function () {
							$scope.tabs.additionalPayments.reload();
						});
					},
					delete: function (additionalPayment) {
						$ngBootbox.confirm('Are you sure you want to do this?')
							.then(function () {
								EmployeeAdditionalPaymentSvc.delete(additionalPayment)
									.then(function () {
										$scope.tabs.additionalPayments.reload();
										notify({
											message: 'Additional payment deleted successfully'
										});
									}, function () {
										notify({
											message: 'Failed to delete additional payment',
											classes: 'error'
										});
									});
							});
					}
				});

				$scope.additionalPayments.applyFilter();

				$scope.tabs.additionalPayments.loaded = true;
			}
		},
		reload: function () {
			$scope.additionalPayments.tableParams.reload();
		}
	});


});
